import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import Login from 'pages/Login';
import TicketServices from 'services/ticket.service';
import { PageViewTracker } from 'components/ApplicationInsights/pageViewTracker';

export default function TicketRating() {
  const location = useLocation();
  const [, setSuccess] = useState(false);
  const [, setLoadingUpdate] = useState(false);

  const _ticketService = new TicketServices();

  async function ratingTicket() {
    const params = queryString.parse(location.search);
    if (params.objectId && params.value !== '') {
      setLoadingUpdate(true);

      await _ticketService
        .rating({ objectId: params.objectId, value: params.value })
        .then(() => {
          setSuccess(true);
          setLoadingUpdate(false);
        })
        .catch(() => {
          setLoadingUpdate(false);
        });
    }
  }

  useEffect(() => {
    ratingTicket();
  }, []);

  return (
    <Login noBottomLogo>
      <PageViewTracker />
      <div className="animated fadeIn">
        <Column>
          <Row>
            <Text size={14} className="color-blue-gray text-wrap">
              Ticket avaliado com sucesso.
            </Text>
          </Row>
        </Column>
      </div>
    </Login>
  );
}
